<template>
  <div class="body">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane v-for="(item,index) in list" :label="item.name" :name="index + ''"></el-tab-pane>
    </el-tabs>
    <div style="padding: 40px">
      <el-form  label-width="200px" >
        <el-form-item v-for="(item,index) in paramList" :label="item.label + ':'">
          <el-input  type="textarea"
                     :rows="4"
                     :autosize="{ minRows: 2, maxRows: 4}"
                     :placeholder="'请输入' + item.label" v-if="item.type === 'text'" v-model="item.value"></el-input>
          <el-input-number
                     :placeholder="'请输入' + item.label" v-if="item.type === 'num'" :min="1" :max="10" v-model="item.value"></el-input-number >
          <div>
            <upload-image v-if="item.type === 'img'" v-model="item.value" @change="(value) => {
              imgChange(index,value)
            }"></upload-image>
          </div>
          <el-image v-if="item.type === 'img'" style="width: 200px" :preview-src-list="[item.value]" :src="item.value">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot">
              请上传或选择图片<span class="dot">...</span>
            </div>
          </el-image>
          <div v-if="item.type === 'option'">
            <el-radio v-for="(opt,optIdx) in item.options" v-model="item.value" :label="opt.value" :key="optIdx" border>{{opt.label}}</el-radio>
          </div>
          <div v-if="item.type === 'slider'">
            <el-slider v-model="item.value" :max="item.max" :min="item.min" :step="item.step"></el-slider>
          </div>
        </el-form-item>
        <el-form-item label="成片:" v-if="res">
          <div class="gallery">
            <div  v-for="(item,index) in res.outputUrls"  class="gallery-item">
              <el-image :preview-src-list="res.outputUrls" :src="item">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
                <div slot="error" class="image-slot" style="color: red;">
                  生成失败<span class="dot">...</span>
                </div>
              </el-image>
            </div>
          </div>

        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="draw">立即生成</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  executeWorkflow, getWorkflowInfo,
  getWorkflowList
} from '@/api/merchant/service/project'
import loading from '@/libs/loading'
import UploadImage from '@/components/uploadImage/index.vue'

/**
 * 富文本工具
 */

export default {
  name: 'aigc',
  components: {
    UploadImage
  },
  data () {
    return {
      list: [],
      selectId: '',
      paramList: [],
      res: null,
      timer: null,
      activeName: 0,
      loading: null
    }
  },
  created () {
  },
  methods: {
    imgChange (index, value) {
      console.log('value', value)
      console.log('index', index)
      this.paramList[index].value = value
      // 强制刷新
      this.$forceUpdate()
    },
    getList () {
      getWorkflowList().then((res) => {
        this.list = res
        this.handleClick()
      })
    },
    handleClick () {
      console.log('this.activeName', this.activeName)
      this.selectId = this.list[this.activeName].id
      this.paramList = JSON.parse(this.list[this.activeName].params)
      console.log(this.paramList)
    },
    draw () {
      let that = this
      // loading
      this.loading = this.$loading({
        lock: true,
        text: '正在生成中(耐心等待几分钟)...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      executeWorkflow(this.selectId, this.paramList).then((res) => {
        if (res.promptId) {
          that.getInfo(res.promptId)
        }
      }
      ).catch(
        () => {
          that.loading.close()
        }
      )
    },
    getInfo (promptId) {
      let that = this
      getWorkflowInfo(promptId).then(
        (res) => {
          if (res && res.id) {
            that.res = res
            if (!res.outputUrls || res.outputUrls.length === 0) {
              //   弹窗提示生成失败
              that.$message.error('生成失败')
            }
            //   删除定时器
            clearInterval(that.timer)
            that.loading.close()
          } else {
            setTimeout(() => {
              that.getInfo(promptId)
            }, 2000)
          }
        }
      ).catch(() => {
        that.loading.close()
      })
    }
  },

  mounted () {
    this.getList()
  }
}
</script>
<style scoped>
.body {
  padding: 40px;
}
#chart {
  width: 100%;
  min-height: 500px;
  margin-top: 20px;
  margin-left: 40px;
}
.gallery {
  display: flex;
  flex-wrap: wrap;
}
.gallery img {
  margin: 5px;
  max-width: 100%;
  height: auto;
}
.gallery-item {
  flex: 1 0 21%; /* 这里的 21% 可以根据需要调整，每行显示几个图片 */
  box-sizing: border-box;
}
.draggable-element {
  position: fixed;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  padding: 40px;
  left: 60px;
  top: 50%;
  cursor: move;
  z-index: 999;
}
.disDiv {
  /* display: flex; */
  border: 1px dotted;
  padding-bottom: 20px;
}
</style>
